import { ManagePanel } from './ManagePanel';
export const ManageConnectionError = () => (
  <ManagePanel className="text-center text-xl md:w-1/2 mx-auto" yOrientation>
    <h2 className="text-pt-primary">Connection interrupted. Reconnecting.</h2>

    <div className="w-6 h-6 mx-auto bg-pt-primary rounded-full animate-ping"></div>
  </ManagePanel>
);
